"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRE_PROD = exports.PROD = exports.STAGE = exports.LOCALHOST = void 0;
exports.LOCALHOST = 'localhost';
exports.STAGE = 'stage';
exports.PROD = 'prod';
exports.PRE_PROD = 'pre-prod';
